import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import CalendarioPagamento from '../../CalendarioPagamento/CalendarioPagamento';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../InfoComponent';

class CalendarioBeneficioParticipante extends Component {

	render() {

		return (

			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>

				<InfoComponent image={"calendario-beneficio-participante"} page={'calendario-pagamento-beneficio'}></InfoComponent>				

				{/* Content page */}
				<div className="_the-content pb-10">
					<div className='container'>
						<div className="row justify-content-center">

							<ErrorBoundary><CalendarioPagamento /></ErrorBoundary>

						</div>
					</div>
				</div>

				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default CalendarioBeneficioParticipante;